/**
 * Hal/borsa fiyat satırındaki `avgPrice` değerinin görünür adı.
 *
 * Kaynakların çoğu işlem ortalaması yayımlamaz; değer en düşük ile en yüksek
 * fiyatın ortasıdır (API'de `avgPriceMethod: "midpoint"`). Ürün kararı
 * (2026-10-04): sitede bu değer "ortalama" değil "orta fiyat" diye anılır.
 * Endeks, perakende zincir ortalaması, dönem (ay/yıl) ortalamaları bu etiketi
 * kullanmaz.
 */
export const PRICE_MID_LABEL = "Orta fiyat";
export const PRICE_MID_SHORT = "Orta";
export const PRICE_MID_NOTE =
  "Orta fiyat: kaynağın bildirdiği ortalama ya da en düşük ile en yüksek fiyatın ortası.";
